import React, {useRef} from 'react';
import styles from './Featured.module.scss'
import panelStyles from '../Panels.module.scss';
import gsap from 'gsap';
import MouseMove from "utils/MouseMove";
import PanelAnimations from "utils/PanelAnimations";
import ImageWrapper from "components/imageWrapper/ImageWrapper";
import mainStyles from "components/homeParallax/HomeParallax.module.scss";
import {useSelector} from "react-redux";
import {buttonClick} from "utils/Helpers";

const Featured = (props) => {

    const siteEntered = useSelector(state => state.accessible.siteEntered);
    const windowData = useSelector(state => state.window);
    const foreGround = useRef();
    const backGround = useRef();
    const fixedStage = useRef();
    const logo = useRef();

    const mouseOver = (e) => {
        let node = e.currentTarget;
        let squares = logo.current.querySelectorAll('.square');
        squares.forEach((square)=>{
            if(square !== node){
                gsap.to(square, {duration: .5, transform: 'perspective(100px) translateZ(-10px)'} )
                square.firstChild.style.pointerEvents = 'none'

            }
            gsap.to(node, {duration: .5, transform: 'perspective(100px) translateZ(10px)'} )
            gsap.to(node.firstChild, {duration: .5, opacity: 1, onComplete: ()=>{
                    if(node)node.firstChild.style.pointerEvents = 'inherit'
                }} )
        })

    }

    const mouseOut = (e) => {
        let squares = logo.current.querySelectorAll('.square');
        squares.forEach((square)=>{
            gsap.to(square, {duration: .5, transform: 'perspective(100px) translateZ(0px)'} )
        })
        gsap.to(e.currentTarget.firstChild, {duration: .5, opacity: 0})
    }

    function featuredLink(e,location){
        e.stopPropagation();
        if(windowData.width > 768) props.linkTo(location)
    }

    return (
        <div ref={fixedStage} className={`${panelStyles.fixedStage}`} style={{zIndex: props.zIndex}}>

            <div className={`${panelStyles.hero}`}>
                <div ref={foreGround} className={`${panelStyles.foreGround} ${styles.content}`}>
                    <div className={styles.featuredLogoWrapper}>
                        <div ref={logo} className={styles.featuredLogo}>
                            <div className={`${styles.square1} square`} onMouseOver={mouseOver} onMouseOut={mouseOut}
                                 onClick={(e)=>featuredLink(e,'contest')}>
                                <div tabIndex={siteEntered ? 0 : null} role={'button'} onKeyDown={buttonClick} aria-label={'Navigate to Surface Originals'} onClick={()=>props.linkTo('contest')}>
                                    <div className={styles.title}>Surface<br/>Originals Contest</div>
                                    <div className={styles.description}>Share something original for a chance to win&nbsp;$25,000</div>
                                </div>
                                <img src={'https://msobd-storage.azureedge.net/images/featured/Dashboard_Squares_Originals.jpg'} alt={'Original By _ Button'}/>
                            </div>
                            <div className={`${styles.square2} square`} onMouseOver={mouseOver} onMouseOut={mouseOut}
                            onClick={(e)=>featuredLink(e,'martellus')}>
                                <div tabIndex={siteEntered ? 0 : null} role={'button'} onKeyDown={buttonClick} aria-label={'Navigate to Original By _'} onClick={()=>props.linkTo('martellus')}>
                                    <div className={styles.title}>Original by <span className={styles.underscore}><img src={'https://msobd-storage.azureedge.net/images/featured/MartySig.png'} alt={'Marty signature'}/></span></div>
                                    <div className={styles.description}>Originals go by many names &mdash; meet some of the&nbsp;boldest</div>
                                </div>
                                <img src={'https://msobd-storage.azureedge.net/images/featured/TopLeft.jpg'} alt={'Original By _ Button'}/>
                            </div>
                            {/*<div className={`${styles.square2} square`} onMouseOver={mouseOver} onMouseOut={mouseOut}*/}
                            {/*onClick={(e)=>featuredLink(e,'spotlight')}>*/}
                            {/*    <div tabIndex={siteEntered ? 0 : null} role={'button'} onKeyDown={buttonClick} aria-label={'Navigate to Original Spotlight'}  onClick={()=>props.linkTo('spotlight')}>*/}
                            {/*        <div className={styles.title}>Originals<br/>Spotlight</div>*/}
                            {/*        <div className={styles.description}>Discover how inspiration fuels these people’s originality.</div>*/}
                            {/*    </div>*/}
                            {/*    <img src={'https://msobd-storage.azureedge.net/images/featured/TopRight.jpg'} alt={'Originals Spotlight Button'}/>*/}
                            {/*</div>*/}
                            <div className={`${styles.square3} square`} onMouseOver={mouseOver} onMouseOut={mouseOut}
                             onClick={(e)=>featuredLink(e,'project-inspire')}>
                                <div tabIndex={siteEntered ? 0 : null} role={'button'} onKeyDown={buttonClick} aria-label={'Navigate to Project Inspire'}  onClick={()=>props.linkTo('project-inspire')}>
                                    <div className={styles.title}>Project<br/>Inspire</div>
                                    <div className={styles.description}>Every original idea inspires the next &mdash; follow the journey</div>
                                </div>
                                <img src={'https://msobd-storage.azureedge.net/images/featured/BottomLeft.jpg'} alt={'Project Inspire Button'}/>
                            </div>
                            <div className={`${styles.square4} square`} onMouseOver={mouseOver} onMouseOut={mouseOut}
                            onClick={(e)=>featuredLink(e,'customize-yours')}>
                                <div tabIndex={siteEntered ? 0 : null} role={'button'} onKeyDown={buttonClick} aria-label={'Navigate to Redesign your Surface'}  onClick={()=>props.linkTo('customize-yours')}>
                                    <div className={styles.title}>Redesign<br/>your Surface</div>
                                    <div className={styles.description}>Surface skins designed for originals, inspired by&nbsp;originals</div>
                                </div>
                                <img src={'https://msobd-storage.azureedge.net/images/featured/BottomRight.jpg'} alt={'Redesign your Surface Button'}/>
                            </div>
                        </div>
                    </div>
                </div>
                <div aria-hidden={true} ref={backGround} className={`${panelStyles.backGround}`}>
                    <ImageWrapper set={{
                        400: 'https://msobd-storage.azureedge.net/images/bg-smoke-430x650.jpg',
                        700: 'https://msobd-storage.azureedge.net/images/bg-smoke-800x790.jpg',
                        1250: 'https://msobd-storage.azureedge.net/images/bg-smoke-1350.jpg',
                        default: 'https://msobd-storage.azureedge.net/images/bg-smoke.jpg'
                    }} alt={''}/>
                </div>

            </div>

            <span className={mainStyles.accessibleContent} tabIndex={siteEntered ? 0 : null} role={'button'} aria-label={'Navigate to next section'} onKeyDown={buttonClick} onClick={props.nextPanel}/>
            <span className={mainStyles.accessibleContent} tabIndex={siteEntered ? 0 : null} role={'button'} aria-label={'Navigate to previous section'} onKeyDown={buttonClick} onClick={props.prevPanel}/>

            <PanelAnimations fixedStage={fixedStage} backGround={backGround} foreGround={foreGround} panel={'featured'}/>
            <MouseMove status={props.status} backGround={backGround}/>

        </div>
    )
};

export default Featured
